<template>
  <el-dialog
    title="批量发货"
    :visible.sync="showImportDialog"
    width="650px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
  >
    <el-form label-width="180px">
      <el-form-item label="下载模板">
        <a href="/static/import-demo.xlsx" target="_blank" >订单导入.xlsx</a>
      </el-form-item>
      <el-form-item label="上传文件">
        <el-upload
          ref="upload"
          action=""
          :limit="1"
          :file-list="fileList"
          :on-change="beforeUpload"
          :auto-upload="false"
          accept=".xlsx"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="dataWs && dataWs.length > 0" label="待上传">
        <div class="color-orange">共检测到 {{ dataWs.length }} 条数据</div>
        <el-progress :percentage="percentage"></el-progress>
      </el-form-item>
      <el-form-item v-if="errorCode && Object.keys(errorCode).length > 0" label="快递公司匹配失败">
        <table v-if="showErr" style="width: 100%">
          <tr>
            <td>原始公司</td>
            <td>更换为</td>
          </tr>
          <tr v-for="(k, index) in Object.keys(errorCode)" :key="index">
            <td>{{ k }}</td>
            <td>
              <el-select v-model="errorCode[k]" filterable placeholder="请选择" @change="v => handleSelect(k, v)">
                <el-option
                  v-for="item in shippingData"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item v-if="errors && errors.length > 0" label="上传/校验失败">
        <el-alert :title="errors.length + ' 条数据上传失败'" type="error" :closable="false"/>
        <div style="max-height: 100px;overflow-y: scroll;">
          <div v-for="(e, index) in errors" :key="index">
            {{ e.d + ': ' + e.e }}
          </div>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="errors && errors.length > 0" type="warning" @click="handleExportError" :loading="btnLoading">导出错误数据</el-button>
      <el-button @click="showImportDialog = false">取 消</el-button>
      <el-button type="primary" @click="handleImport" :loading="btnLoading">开始导入</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  createShipper,
  getShipperList
} from '@/api/order.js';
import XLSX from 'xlsx';

export default {
  data() {
    return {
      finished: 0,
      btnLoading: false,
      showImportDialog: false,
      dataWs: [],
      shippingData: [],
      shippingObject: {},
      fileList: [],
      errorCode: {},
      showErr: true,
      errors: [],
      mapToName: {
        '韵达': '韵达速递',
        '韵达国际': '韵达速递',
        '韵达快运': '韵达速递',
        '中国邮政': '邮政快递包裹',
        '邮政包裹/平邮': '邮政快递包裹',
        '申通': '申通快递',
        '中通': '申通快递',
        '京东物流': '京东快递',
        '顺丰': '顺丰速运',
        '圆通快递': '圆通速递'
      }
    }
  },
  computed: {
    percentage: function() {
      let total = this.dataWs.length
      if (total < 1) return 0
      return parseFloat(Math.ceil(this.finished / total * 100));
    }
  },
  methods: {
    handleSelect(k, v) {
      console.log(k, v)
      this.showErr = false
      this.errorCode[k] = v
      this.showErr = true
    },
    sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time))
    },
    show() {
      this.showImportDialog = true;

      getShipperList().then(res => {
        this.shippingData = res || [];
        this.shippingData.forEach(d => {
          this.shippingObject[d.name] = d.code
        })
      })
    },
    async beforeUpload(file) {
      this.errors = [];
      this.finished = 0
      const data = await file.raw.arrayBuffer();
      const workbook = XLSX.read(data, {type:'array'});

      const sheetName = workbook.SheetNames[0];
      const ws = workbook.Sheets[sheetName];
      const dataWs = XLSX.utils.sheet_to_json(ws, {header: ['order_id', 'name', 'logistic_code'], defval: ''});

      dataWs.shift()
      this.formatCode(dataWs)
      // this.dataWs = dataWs;
      return false;
    },
    // 解析物流公司名称
    formatCode(dataWs) {
      this.dataWs = dataWs.map(d => {
        
        let order_id = d.order_id || null;
        let name = d.name || null;
        let logistic_code = d.logistic_code || null

        if (this.mapToName[name]) {
          name = this.mapToName[name]
        }

        if (!order_id || !order_id.includes('202')) {
          this.errors.push({
            d: order_id + ':',
            e: '订单编号错误'
          })
        } else {
          d.order_id = d.order_id.replace(/\n|\r|\t|\s/g, '')
        }

        if (!name) {
          this.errors.push({
            d: d.order_id + ':',
            e: '物流公司不存在'
          })
        } else {
          d.name = name.replace(/\n|\r|\t|\s/g, '')
        }

        if (!logistic_code) {
          this.errors.push({
            d: d.order_id + ':',
            e: '物流单号不能为空'
          })
        } else {
          d.logistic_code = d.logistic_code.replace(/\n|\r|\t|\s/g, '')
        }

        if (this.shippingObject[d.name]) {
          d.shipper_code = this.shippingObject[d.name]
        } else if (!this.errorCode[d.name]){
          this.errorCode[d.name] = ''
        }
        return d;
      })
    },
    async handleImport() {
      this.btnLoading = true;
      this.finished = 0;
      this.errors = [];
      for (let index = 0; index < this.dataWs.length; index ++) {
        const item = this.dataWs[index];

        const order_id = item.order_id || null;
        const name = item.name || null;
        const shipper_code = item.shipper_code || this.errorCode[name] || null;
        const logistic_code = item.logistic_code || null;

        this.finished = index + 1

        try {
          await createShipper(order_id, { shipper_code, logistic_code })
        } catch (e) {
          this.errors.push({
            d: item.order_id,
            e: this.formatErrors(e.data)
          })
        }
        await this.sleep(100)
      }

      this.btnLoading = false;
    },
    handleExportError() {
      this.btnLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['订单编号', '错误原因']
        const filterVal = ['d', 'e']
        const data = this.formatJson(filterVal, this.errors)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '订单导入失败-' + (new Date()).toJSON(),
          autoWidth: true,
          bookType: 'xlsx'
        })
        this.btnLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    formatErrors(e) {
      if (e.error) return e.error
      else if (typeof e === 'object') {
        let keys = Object.keys(e);
        return e[keys[0]] || '未知错误'
      }
    },
  }
}
</script>